import React, { forwardRef, Fragment } from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../Box";
import { Badge } from "../Badge";
import { Flex } from "../Flex";
const ListingWrapper = styled.div `
  ${({ theme, open = false, maxHeight }) => {
    const { colors: { deprecatedSearchBoxColors }, } = theme;
    return {
        backgroundColor: deprecatedSearchBoxColors.listingBackground,
        border: "none",
        borderRadius: "5px",
        boxShadow: "0 6px 18px 0 rgba(0, 0, 0, 0.15)",
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        maxHeight: open ? maxHeight : "0px",
        overflow: maxHeight ? "scroll" : "hidden",
        transition: "all 200ms",
        width: "100%",
        zIndex: 99999,
    };
}}
`;
export const DeprecatedSearchBoxListing = forwardRef((props, ref) => {
    const { colors: { deprecatedSearchBoxColors }, } = useTheme();
    const { title, children, open, maxHeight, floatingProps, floatingStyles } = props;
    return (React.createElement(ListingWrapper, Object.assign({ ref: ref, open: open, maxHeight: maxHeight, style: floatingStyles }, floatingProps),
        title && (React.createElement(Flex, { p: "2", backgroundColor: deprecatedSearchBoxColors.listingTitleBackground }, title)),
        React.createElement(Flex, null, children)));
});
export const DeprecatedSearchBoxListingContent = ({ keywords, legendText, }) => (React.createElement(Box, { p: 2, lineHeight: "12px" },
    React.createElement("div", null, legendText),
    React.createElement("br", null),
    React.createElement("div", null, keywords.map((keyword, index) => (React.createElement(Fragment, { key: `${keyword}-${index}` },
        index ? "," : "",
        React.createElement(Badge, { key: keyword, variant: "chip", inverted: true, label: keyword, addTestId: false })))))));
